module.exports = __webpack_public_path__ + "static/media/MzCare_Logo-02.2eb1ecd2.svg";